import { createInstance } from 'localforage';

export type LocalForageDb = ReturnType<typeof createInstance>;

export class LocalForageDbService {
  /* Prevent instantiation */
  private constructor() {}

  /**
   * Creates a local database instance with the specified repository name.
   * @param repoName The name of the repository (store) to create.
   */
  static createInstance(repoName: string) {
    return createInstance({
      name: 'data-collection/apps/client-web',
      storeName: repoName,
    });
  }
}
